import { render } from "./GreenTeam.vue?vue&type=template&id=740284e4&scoped=true"
import script from "./GreenTeam.vue?vue&type=script&lang=js"
export * from "./GreenTeam.vue?vue&type=script&lang=js"

import "./GreenTeam.vue?vue&type=style&index=0&id=740284e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740284e4"]])

export default __exports__